import {
  checkStatus,
  parseJSON,
  getApiUrl,
  getHeaderForAjax,
} from "./ServiceHelper";
import { langUpdate } from "./UserService";
async function getUserByEmail(authData, isRememberMe, lang) {
  try {
    const response = await fetch(
      getApiUrl() + "/users/email/" + authData.subs,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token: authData.access_token,
        },
      }
    );
    checkStatus(response);
    const userData = await response.json();
    if (lang) {
      setTimeout(async () => await langUpdate(userData._id, lang), 500);
    }
    return { authData, userData, isRememberMe };
  } catch (error) {
    console.error("Error fetching user by email:", error);
    throw error; // Rethrow the error after logging it for further handling if necessary
  }
}

export function authenticate(user, isRememberMe, lang) {

  return fetch(getApiUrl() + "/security/authenticate", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      email: user.email,
      password: user.password,
    },
  })
    .then(function (response) {
      return checkStatus(response);
    })
    .then(function (resp) {
      return resp.json();
    })
    .then(function (authData) {
      if (authData.message !== undefined) {
        return Error(authData.message);
      } else {
        return getUserByEmail(authData, isRememberMe, lang);
      }
    });
}

export function forgotPassword(email) {
  return fetch(getApiUrl() + "/users/forgotpassword", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(email),
  })
    .then(checkStatus)
    .then(parseJSON);
}

export function forgotPasswordReset(resetForm) {
  return fetch(getApiUrl() + "/users/forgotpassword", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(resetForm),
  })
    .then(checkStatus)
    .then(parseJSON);
}

export function resetPassword(passwords) {
  return fetch(getApiUrl() + "/resetpassword", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(passwords),
  })
    .then(checkStatus)
    .then(parseJSON);
}

export function changePassword(passwords) {
  return fetch(getApiUrl() + "/users/resetpassword", {
    method: "POST",
    headers: getHeaderForAjax(),
    body: JSON.stringify(passwords),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export function activeUser(e) {
  let url =
    getApiUrl() +
    "/users/activation/?code=" +
    e.code +
    "&subscriber=" +
    e.subscriber +
    (e.lang ? "&lang=" + encodeURIComponent(e.lang) : "");
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
    },
  })
    .then(checkStatus)
    .then(parseJSON);
}



// WEBPACK FOOTER //
// ./src/services/LoginService.js